module.exports = __webpack_public_path__ + "img/idcardback.60e9614f.png";